export default "__VITE_ASSET__DqxVL7$___"